export default [
    {
        path: 'fechamento-viagem',
        component: () => import('@/views/transporte-paciente/fechamento-viagem/Index'),
        redirect: 'fechamento-viagem/form',
        children: [
            {
                name: 'fechamento-viagem-form',
                path: 'form',
                component: () => import('@/views/transporte-paciente/fechamento-viagem/Form.vue'),
            },
        ],
    },
]